// eslint-disable-next-line @typescript-eslint/no-require-imports
import _ from 'lodash';

function secureURL(url) {
  return url.replace('http://', 'https://');
}

const MOBILE_THRESHOLD = '768px';

/* ---------- User agent ---------------------------------------------------- */

const computeUserAgent = ctx => {
  if (ctx && ctx.req) {
    return isMobileUserAgent(ctx.req.headers['user-agent']);
  }

  if (window) {
    return isMobileUserAgent(window.navigator.userAgent);
  }

  return false;
};

const bootstrapBreakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

function isSmallScreen() {
  if (typeof window !== 'undefined') {
    return window.innerWidth < bootstrapBreakpoints.md;
  }
  return false;
}

function isMobileUserAgent(userAgent) {
  // A complex regex can also be used to detect mobile userAgents, but this should theoretically cover 99.5%+ of users and
  // currently covers 100% of mobile users.
  if (
    _.includes(userAgent, 'Mobi') ||
    _.includes(userAgent, 'iPhone') ||
    _.includes(userAgent, 'Android')
  ) {
    return true;
  }
  return false;
}

function isChromeUserAgent(userAgent) {
  // Implemented based on this
  // https://developer.chrome.com/multidevice/user-agent
  if (_.includes(userAgent, 'Chrome') || _.includes(userAgent, 'CriOS')) {
    return true;
  }
  return false;
}

function isFirefoxUserAgent(userAgent) {
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/User-Agent/Firefox
  return _.includes(userAgent, 'Firefox');
}

function isNodeFetchUserAgent(userAgent) {
  // Necessary so that the chrome-detection code does not interfere with frontend tests
  return _.includes(userAgent, 'node-fetch');
}

function isUsingWindows(userAgent) {
  return userAgent.toUpperCase().includes('WINDOW');
}

/* ---------- DOM ----------------------------------------------------------- */

function preventDefault(e) {
  e.preventDefault();
}

function stopPropagation(e) {
  e.stopPropagation();
}

/* ---------- React --------------------------------------------------------- */

function getComponentName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function getWrapperComponentName(hocName, WrappedComponent) {
  return `${hocName}(${getComponentName(WrappedComponent)})`;
}

/* ---------- JS ------------------------------------------------------------ */

// Convenience functions to treat an array as a set. Useful when you
// want to avoid doing Array.from(set.values())—for instance, we need
// new arrays for FrameControlPanel otherwise it won't get updated.
const aset = {
  add(a, value) {
    const idx = a.indexOf(value);
    if (idx === -1) a.push(value);
  },

  delete(a, value) {
    const idx = a.indexOf(value);
    if (idx > -1) a.splice(idx, 1);
  },

  has(a, value) {
    return a.indexOf(value) !== -1;
  },
};

const util = {
  aset,
  secureURL,
  computeUserAgent,
  isMobileUserAgent,
  isSmallScreen,
  isChromeUserAgent,
  isFirefoxUserAgent,
  isNodeFetchUserAgent,
  isUsingWindows,
  getWrapperComponentName,
  preventDefault,
  stopPropagation,
  MOBILE_THRESHOLD,
};

export default util;
export {
  aset,
  secureURL,
  computeUserAgent,
  isMobileUserAgent,
  isSmallScreen,
  isChromeUserAgent,
  isFirefoxUserAgent,
  isNodeFetchUserAgent,
  isUsingWindows,
  getWrapperComponentName,
  preventDefault,
  stopPropagation,
  MOBILE_THRESHOLD,
};
